import React from 'react';
import { Scroll } from 'lucide-react';

export const TermsOfUsePage: React.FC = () => {
  return (
    <div className="p-6 pt-8 min-h-[calc(100vh-4rem)]">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center space-x-4 mb-8">
          <div className="w-16 h-16 rounded-full bg-purple-500/20 flex items-center justify-center">
            <Scroll className="w-8 h-8 text-purple-300" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-purple-200">Termos de Uso</h1>
            <p className="text-purple-300/70">Última atualização: {new Date().toLocaleDateString()}</p>
          </div>
        </div>

        <div className="space-y-8 text-purple-200/90">
          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">1. Aceitação dos Termos</h2>
            <p>
              Ao acessar e usar o Celestial Guide, você concorda em cumprir e estar vinculado aos seguintes termos e condições.
              Se você não concordar com qualquer parte destes termos, não deverá usar nossos serviços.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">2. Descrição dos Serviços</h2>
            <p>O Celestial Guide oferece:</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Consultas astrológicas online</li>
              <li>Mapas astrais personalizados</li>
              <li>Previsões e interpretações astrológicas</li>
              <li>Conteúdo educacional sobre astrologia</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">3. Conta do Usuário</h2>
            <p>Para usar nossos serviços, você deve:</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Fornecer informações precisas e completas</li>
              <li>Manter suas credenciais de login seguras</li>
              <li>Ser responsável por todas as atividades em sua conta</li>
              <li>Ter pelo menos 18 anos de idade</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">4. Pagamentos e Reembolsos</h2>
            <p>
              Os preços dos serviços estão sujeitos a alterações. Reembolsos podem ser solicitados em até 7 dias após a compra,
              desde que o serviço não tenha sido utilizado.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">5. Propriedade Intelectual</h2>
            <p>
              Todo o conteúdo disponível no Celestial Guide, incluindo textos, gráficos, logos, imagens e software,
              é propriedade exclusiva da empresa ou de seus licenciadores.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">6. Limitação de Responsabilidade</h2>
            <p>
              O Celestial Guide fornece informações e interpretações astrológicas para fins de entretenimento e autoconhecimento.
              Não nos responsabilizamos por decisões tomadas com base em nossas previsões.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">7. Modificações dos Termos</h2>
            <p>
              Reservamo-nos o direito de modificar estes termos a qualquer momento. As alterações entrarão em vigor
              imediatamente após sua publicação no site.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">8. Contato</h2>
            <p>
              Para questões relacionadas a estes termos, entre em contato através do email: suporte@celestialguide.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};